import React from 'react';

import VoucherList from './VoucherList';

export default function VoucherTabs() {
    return <VoucherList />;
}
